module.exports = __webpack_public_path__ + "img/tryagent-01.065f69e.webp";